import { render } from "./SalesReport.vue?vue&type=template&id=4391248d&scoped=true&ts=true"
import script from "./SalesReport.vue?vue&type=script&lang=ts"
export * from "./SalesReport.vue?vue&type=script&lang=ts"

import "./SalesReport.vue?vue&type=style&index=0&id=4391248d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4391248d"]])

export default __exports__